// extracted by mini-css-extract-plugin
export default {"InputContainer":"Styles_InputContainer__XTe8H","InputInvalid":"Styles_InputInvalid__KRRuh","SuggestionBox":"Styles_SuggestionBox__Pnh3o"};